import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { useUpdateAddressMutation } from '../../features/fullApi';
import { toast } from 'react-hot-toast';
import { Country, State, City }  from 'country-state-city';

export default function EditDialog({openEdit, setOpenEdit, item}) {

    const user = JSON.parse(localStorage.getItem('user'))
    const [updateAddress] = useUpdateAddressMutation()

    const [country, setCountry] = useState("")
    const [state, setState] = useState("")
    const [city, setCity] = useState("")
    const [countryCode, setCountryCode] = useState("")
    
    const countries = Country.getAllCountries()
    const allStates = State.getAllStates()
  
    const [states, setStates] = useState([])
    const [cities, setCities] = useState([])
  
    const handleChangeCountry = (e) => {
      console.log("e is", e)
      setCountry(e)
      setStates(State.getStatesOfCountry(e.isoCode))
      setCountryCode(e.isoCode)
      setCity("")
    }
  
    const handleChangeState = (e) => {
      setState(e)
      console.log("e is ", e)
      setCities(City.getCitiesOfState(e.countryCode, e.isoCode))
      handleChangeCity(City.getCitiesOfState(e.countryCode, e.isoCode).filter(city => city.name === item.city)[0])
    }
  
    const handleChangeCity = (e) => {
      setCity(e)
    }

    const onSubmit = async(values, actions) => {
        // console.log("Called on submit", values.brandName)
        //   updateAddress({_id: item._id, name: values.name, surname: values.surname, street: values.street, city: values.city, zipcode: values.zipcode, countryCode: values.countryCode }, { 
        //   headers: {
        //       'Token': `Bearer ${user?.accessToken}`
        //   }
        //   }, {id: item._id})
        //   .then(res => {
        //     console.log("res is")
        //   })
        //   .catch((e) => {
        //   console.log("e is", e)
        //   })
    }

    const handleUpdateAddress = (address) => {
        updateAddress(
          {_id: item._id, name: address.name, surname: address.surname, country: country.name, city: city.name, state: state.name, street: address.street, zipcode: address.zipcode, countryCode: address.countryCode}, 
          { headers: {'Token': `Bearer ${user?.accessToken}`}}, 
          {id: item._id})
        .then(res => {
          toast.success(`Address updated successfully`)
        })
        .catch((e) => {
        })
      }
      
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          name: item?.name,
          surname: item?.surname,
          country: item?.country,
          state: item?.state,
          city: item?.city,
          street: item?.street,
          zipcode: item?.zipcode
        },
        onSubmit,
      });

      useEffect(() => {
        console.log("open edit is", openEdit)
        console.log("item.state", item)
        if(openEdit) {
          handleChangeCountry(countries.filter(country => country.name===item.country)[0])
          handleChangeState(allStates.filter(state => state.name===item.state)[0])
        }
      }, [openEdit])

    return (
        <form onSubmit={handleSubmit} >
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenEdit(false)} open={openEdit}>
                <DialogTitle id='dialog-title'>
                    Edit Address
                </DialogTitle>
                <DialogContent>
                    <DialogContentText style={{color: "red"}}>You are editing address</DialogContentText>
                    <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <TextField
                  id="name"
                  type="text"
                  value={values.name}    
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="name"
                  margin="dense"
                  size="small"
                />
              </FormControl>
              {errors.name && touched.name && <p className="error">{errors.name}</p>}

              <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
                  id="surname"
                  type="text"
                  margin="dense"
                  value={values.surname}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  label="surname"
                  size="small"
              />
              </FormControl>
              {errors.surname && touched.surname && (
                <p className="error">{errors.surname}</p>
              )}

<FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>Country</InputLabel>
                <Select
                  id="country"
                  value={country}
                  label="Country"
                  onChange={(e) => handleChangeCountry(e.target.value)}
                >
                    {countries?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.country && touched.country && (
                <p className="error">{errors.country}</p>
              )}
        
            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>State</InputLabel>
                <Select
                  id="state"
                  value={state}
                  label="State"
                  onChange={(e) => handleChangeState(e.target.value)}
                >
                    {states?.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.state && touched.state && (
                <p className="error">{errors.state}</p>
              )}


            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
                <InputLabel>City</InputLabel>
                <Select
                  id="state"
                  value={city}
                  label="State"
                  onChange={(e) => handleChangeCity(e.target.value)}
                >
                    {cities.map((option) => (
                    <MenuItem key={option.name} value={option}>
                      {option.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {errors.city && touched.city && (
                <p className="error">{errors.city}</p>
              )}
        
            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="street"
              type="text"
              margin="dense"
              value={values.street}
              onChange={handleChange}
              onBlur={handleBlur}
              label="street"
              size="small"
            />
            </FormControl>
              {errors.street && touched.street && (
                <p className="error">{errors.street}</p>
              )}


            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
            <TextField
              id="zipcode"
              type="number"
              margin="dense"
              value={values.zipcode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="zipcode"
              size="small"
            />
            </FormControl>
              {errors.zipcode && touched.zipcode && (
                <p className="error">{errors.zipcode}</p>
              )}

            <FormControl fullWidth style={{marginBottom: '10px'}} size="small">
              <TextField
              id="countryCode"
              type="text"
              margin="dense"
              value={countryCode}
              onChange={handleChange}
              onBlur={handleBlur}
              label="Country Code"
              size="small"
              disabled
            />
            </FormControl>
              {errors.countryCode && touched.countryCode && (
                <p className="error">{errors.countryCode}</p>
              )}

                </DialogContent>
                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => setOpenEdit(false)}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        onClick={() => handleUpdateAddress(values)}
                    >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}